import React from 'react';

const ContactForm = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  return (
    <div className="h-full flex flex-col">
      {/* Préférences de contact en haut */}
      <div className="form-group mb-6">
        <label className="required-label text-[22px] font-medium text-[#2d2d2d] mb-4 block">
          La prochaine étape :
        </label>
        <div className="space-y-3">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="contact_preference"
              value="rappel"
              checked={data.contact_preference === 'rappel'}
              onChange={(e) => handleChange('contact_preference', e.target.value)}
              className="w-4 h-4 text-[#fa6800] border-2 border-[#d8dde5] focus:ring-[#fa6800] focus:ring-2"
              data-testid="contact-preference-rappel"
            />
            <span className="text-[#2d2d2d]">Rappelez moi dans les 48h</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="contact_preference"
              value="rdv_mail"
              checked={data.contact_preference === 'rdv_mail'}
              onChange={(e) => handleChange('contact_preference', e.target.value)}
              className="w-4 h-4 text-[#fa6800] border-2 border-[#d8dde5] focus:ring-[#fa6800] focus:ring-2"
              data-testid="contact-preference-rdv-mail"
            />
            <span className="text-[#2d2d2d]">Proposez moi une date de rdv par mail</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="contact_preference"
              value="email_programme"
              checked={data.contact_preference === 'email_programme'}
              onChange={(e) => handleChange('contact_preference', e.target.value)}
              className="w-4 h-4 text-[#fa6800] border-2 border-[#d8dde5] focus:ring-[#fa6800] focus:ring-2"
              data-testid="contact-preference-email-programme"
            />
            <span className="text-[#2d2d2d]">Envoyez moi le programme par mail</span>
          </label>
        </div>
      </div>

      {/* Prénom et Nom */}
      <div className="grid grid-cols-2 gap-4">
        <div className="form-group">
          <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 mt-4 block">
            Prénom
          </label>
          <input
            type="text"
            value={data.prenom}
            onChange={(e) => handleChange('prenom', e.target.value)}
            className="form-input w-full"
            placeholder="Votre prénom"
            data-testid="contact-prenom"
          />
        </div>
        <div className="form-group">
          <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 mt-4 block">
            Nom
          </label>
          <input
            type="text"
            value={data.nom}
            onChange={(e) => handleChange('nom', e.target.value)}
            className="form-input w-full"
            placeholder="Votre nom"
            data-testid="contact-nom"
          />
        </div>
      </div>

      {/* Fonction et Entreprise */}
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="form-group">
          <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 block">
            Votre fonction
          </label>
          <input
            type="text"
            value={data.fonction}
            onChange={(e) => handleChange('fonction', e.target.value)}
            className="form-input w-full"
            placeholder="Ex: Directeur RH"
            data-testid="contact-fonction"
          />
        </div>
        <div className="form-group">
          <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 block">
            Votre entreprise
          </label>
          <input
            type="text"
            value={data.entreprise}
            onChange={(e) => handleChange('entreprise', e.target.value)}
            className="form-input w-full"
            placeholder="Nom de l'entreprise"
            data-testid="contact-entreprise"
          />
        </div>
      </div>

      {/* Téléphone */}
      <div className="form-group mt-4">
        <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 block">
          Numéro de téléphone
        </label>
        <input
          type="tel"
          value={data.telephone}
          onChange={(e) => handleChange('telephone', e.target.value)}
          className="form-input w-full"
          placeholder="Ex: 06 12 34 56 78"
          data-testid="contact-telephone"
        />
      </div>

      {/* Email */}
      <div className="form-group mt-4">
        <label className="required-label text-sm font-medium text-[#2d2d2d] mb-2 block">
          Email
        </label>
        <input
          type="email"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
          className="form-input w-full"
          placeholder="votre.email@entreprise.com"
          data-testid="contact-email"
        />
      </div>
    </div>
  );
};

export default ContactForm;